export default {
  state: {
    qualifiedDriver: {
      list: [],
      details: {},
      refresh: false,
      active: false
    }
  },
  mutations: {
    setQualifiedDriversData (state, data) {
      for (let field in data) {
        state.qualifiedDriver[field] = data[field]
      }
    },
    reduceQualifiedDrivers (state) {
      state.qualifiedDriver.list.shift()
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/dispatch/quilified-drivers.js